import React from 'react';
import {
  ContactItemDiv,
  ContactItemIcon,
  ContactItemLink,
  ContactItemTitle
} from './styled';

interface ContactsItemProps {
  icon?: React.ReactNode;
  text?: string;
  index?: number;
  path?: string;
  isButton?: boolean;
  clickHandler?: () => void;
}

export const ContactsItem: React.FC<ContactsItemProps> = ({
  icon,
  text,
  index,
  path,
  isButton,
  clickHandler
}) =>
  isButton ? (
    <ContactItemDiv
      role="button"
      tabIndex={-1}
      onClick={clickHandler}
      onKeyPress={clickHandler}
      data-cy="contact-us-link"
    >
      <ContactItemIcon>{icon}</ContactItemIcon>
      <ContactItemTitle>{text}</ContactItemTitle>
    </ContactItemDiv>
  ) : (
    <ContactItemLink
      href={path}
      role="button"
      tabIndex={index}
      data-cy="contact-us-link"
    >
      <ContactItemIcon>{icon}</ContactItemIcon>
      <ContactItemTitle>{text}</ContactItemTitle>
    </ContactItemLink>
  );
